import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { UserService } from 'app/main/pages/administration-area/services/user.service';
import { AcceptanceService } from 'app/main/services/acceptance.service';
import { UtilsService } from 'app/main/services/utils.service';
import { AlertComponentComponent } from '../../alert/alert-component/alert-component.component';
import { LoaderService } from '../../services/loaderService.service';

@Component({
  selector: 'app-user-form-tac-and-pac',
  templateUrl: './user-form-tac-and-pac.component.html',
  styleUrls: ['./user-form-tac-and-pac.component.scss']
})
export class UserFormTacAndPacComponent implements OnInit {

  formGroup: FormGroup;
  @Input() user: any;
  @Input() isEdit: boolean;
  @Input() showDeleteMyAccountRequestSection: boolean;
  @Output() formData: EventEmitter<any>;

  constructor(
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private acceptanceService: AcceptanceService,
    public dialog: MatDialog,
    private utilsService: UtilsService,
    private userService: UserService) {
    this.formData = new EventEmitter();
  }

  ngOnInit() {
    this.formGroup = this.fb.group({
      pacAccepted: new FormControl(this.user.pacAccepted, Validators.compose([Validators.requiredTrue])),
      tacAccepted: new FormControl(this.user.tacAccepted, Validators.compose([Validators.requiredTrue]))
    });
  }


  async downloadTheActivePrivacyAndCookies() {
    this.loaderService.showLoader();
    const res: any = await this.acceptanceService
      .downloadTheActivePrivacyAndCookies()
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.loaderService.hideLoader();
      });

  }

  async downloadTheActiveTermsAndConditions() {
    this.loaderService.showLoader();
    const res: any = await this.acceptanceService
      .downloadTheActiveTermsAndConditions()
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.loaderService.hideLoader();
      });

  }

  setAcceptance() {
    this.formData.emit(this.formGroup.value);
  }

  deleteMyAccountRequest() {
    const confirmDialog = this.dialog.open(
      AlertComponentComponent,
      {
        width: '400px',
        maxHeight: '80vh',
        data: {
          innerHTML: true,
          body:
            'Se confermi, avvierai la procedura di cancellazione del tuo account. Vuoi procedere?',
          buttons: [
            {
              text: 'Annulla',
              color: 'default',
              close: true,
              value: false,
              callback: async () => {
                confirmDialog.close();
              }
            },
            {
              text: 'Conferma',
              color: 'primary',
              close: false,
              value: true,
              callback: () => {
                this.loaderService.showLoader();
                this.userService.deleteMyAccountRequest()
                  .then((res: any) => {
                    this.utilsService.newSuccessSnackbar(
                      `Richiesta inviata.`
                    );
                  })
                  .catch((err) => {
                    console.error(err);
                  })
                  .finally(() => {
                    this.loaderService.hideLoader();
                    confirmDialog.close();
                  });
              }
            }
          ]
        }
      }
    );
  }
}
